// Password Validation

/*!
 * Validates pasword for lenght, symbols and other criteria.
 */

window.ValidatePassword = function () {
  var rules = [
    {
      Pattern: "[A-Z]",
      Target: "pwUpperCase",
    },
    {
      Pattern: "[a-z]",
      Target: "pwLowerCase",
    },
    {
      Pattern: "[0-9]",
      Target: "pwNumbers",
    },
    {
      // Escaped RegExp for special characters. Note double backslashes.
      // !"#€$%&'()*+,-./:;<=>?@[\]^_`{|}~
      Pattern: "[!\"#\\€$%&'()*+,\\-./:;<=>?@[\\]\\\\^_`{|}~]",
      Target: "pwSymbols",
    },
  ];

  // Just grab the password once
  var password = $(this).val();

  console.log("Password: ", password); // Debugging output

  // Length Check, add and remove class
  var lengthCriteriaMet = password.length > 7;
  $("#pwLenght").removeClass(lengthCriteriaMet ? "unfulfilled" : "fulfilled");
  $("#pwLenght").addClass(lengthCriteriaMet ? "fulfilled" : "unfulfilled");

  // Iterate remaining rules
  for (var i = 0; i < rules.length; i++) {
    var isMatch = new RegExp(rules[i].Pattern).test(password);
    console.log("Rule " + rules[i].Target + " matched: " + isMatch); // Debugging output

    $("#" + rules[i].Target).removeClass(isMatch ? "unfulfilled" : "fulfilled");
    $("#" + rules[i].Target).addClass(isMatch ? "fulfilled" : "unfulfilled");
  }
};

/*Bind event to key up for the field*/
$(document).ready(function () {
  $("#novoGeslo").on("keyup", ValidatePassword);

  // Attach a change event listener to the checkbox using event delegation
  $(document).on("change", "#showPasswordToggle", function () {
    // Determine the state of the checkbox
    var isChecked = $(this).is(":checked");

    // Toggle the type attribute of all inputs currently set as 'password' or 'text'
    $("input").each(function () {
      var $this = $(this);
      // Check if the input is of type 'password' or 'text' to handle both states
      if ($this.attr("type") === "password" || $this.attr("type") === "text") {
        $this.attr("type", isChecked ? "text" : "password");
      }
    });
  });
});
